import { createContext } from 'react'

export const defaultContext = {
  searchResults: undefined as SearchResultsType | undefined,
  isLoading: true as boolean,
  error: false as boolean,
}

const SearchResultsContext = createContext(defaultContext)

export default SearchResultsContext
